import React from 'react';
import { getCurrentUser } from '../../services/authService';
import imgParams from '../../utils/imageUtil';
import {
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  ListItemSecondaryAction,
  Typography,
  Box,
} from '@material-ui/core';
import CustomButton from '../common/customButton';
import MemberIcon from '../../img/followers.svg';
import { numberCountFormatter, ellipsize } from '../../utils/textUtil';
import AdapterLink from '../common/adapterLink';
import { useTablet } from '../../hooks/utilHooks';
import queryString from 'query-string';
import useReactRouter from 'use-react-router';
import { useCommunityListItem } from '../../hooks/communityHooks';

const CommunityListItem = ({ post: item, isShowDescription }) => {
  const { history } = useReactRouter();
  const pathname = window && window.location && window.location.pathname;
  isShowDescription = true;
  const qs = queryString.parse(document.location.search);
  const isTablet = useTablet();
  const user = getCurrentUser();
  const { isJoined, clickToJoin, classes } = useCommunityListItem({ item });

  return (
    <React.Fragment>
      {item && (
        <Box className={classes.mainListItem}>
          <ListItem className={classes.listItem}>
            <Box
              to={(item && item.communitySlug) || ''}
              component={AdapterLink}
              className="textDecorationHidden"
              display="flex"
              alignItems="center"
            >
              <ListItemAvatar>
                <Avatar
                  alt={item.logoAltText}
                  src={imgParams(item.thumbnailImageUrl, 80, 80)}
                  className="defaultBorder"
                ></Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  qs.q && qs.type === 'communities' ? (
                    <Box variant="body2" color="textPrimary">
                      <div
                        className={classes.commName}
                        dangerouslySetInnerHTML={{
                          __html: item.name,
                        }}
                      ></div>
                    </Box>
                  ) : (
                    <React.Fragment>
                      <Typography
                        className={classes.commName}
                        color="textPrimary"
                        variant="body2"
                      >
                        {isTablet
                          ? ellipsize(item.name, 20)
                          : ellipsize(item.name, 50)}
                      </Typography>
                      <Typography color="textSecondary">
                        {item.communityType}
                      </Typography>
                    </React.Fragment>
                  )
                }
                secondary={
                  item.numberOfMembers > 0 && (
                    <Typography
                      variant="caption"
                      color="textSecondary"
                      className={classes.memberText}
                    >
                      <img
                        src={MemberIcon}
                        alt="Member Icon"
                        className={classes.memberIcon}
                      />
                      {numberCountFormatter(item.numberOfMembers)}
                      {item.numberOfMembers > 1 ? ' members' : ' member'}
                    </Typography>
                  )
                }
              />
            </Box>
            {!item.isShop ? (
              pathname === '/mutual-communities-joined' ||
              pathname.split('/')[1] === 'search' ? (
                ''
              ) : (
                <ListItemSecondaryAction className={classes.listItemAction}>
                  <CustomButton
                    variant="outlined"
                    text={isJoined ? 'Joined' : 'Join'}
                    size="regular"
                    className={
                      isJoined
                        ? `${classes.unJoinBtn} ${classes.joinBtn}`
                        : classes.joinBtn
                    }
                    onClick={() => clickToJoin(item.id, user.id, history)}
                  ></CustomButton>
                </ListItemSecondaryAction>
              )
            ) : (
              ''
            )}
          </ListItem>
          <Box
            width={isTablet ? '82%' : '90%'}
            className={classes.itemDescription}
          >
            {isShowDescription && (
              <Typography
                color="textPrimary"
                variant="caption"
                to={(item && item.communitySlug) || ''}
                component={AdapterLink}
                className="textDecorationHidden"
              >
                {isTablet
                  ? ellipsize(item.description, 70)
                  : ellipsize(item.description, 140)}
              </Typography>
            )}
          </Box>
          <Box className="clearfix"></Box>
        </Box>
      )}
    </React.Fragment>
  );
};

export default CommunityListItem;
